import crypto from "./encrypt";
import qs from "qs";

/**
 * 带有签名的导出方法
 * @param {string} url 完整URL地址
 * @param {Record<string,string>} params 请求参数
 */
const exportWithSign = (url, params) => {
  const timestamp = Date.now() + 1000 * 60 * 1;
  params.timestamp = timestamp;
  const sign = crypto.generateSign(params);
  params.sign = sign;
  params.token = localStorage.getItem("token") || "";
  window.open(`${url}?${qs.stringify(params)}`);
};

export default exportWithSign;
